/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableColumn } from '@app/shared/data-table/data-table.component';
import { IrisSummary } from '@app/types/gstr1.type';

export const DEFAULT_EMAIL_CONTENT_HTML =
  '<p>Dear Customer,</p><br><p>We are sending you the invoices with details of sales made to you for the month. These are to be uploaded or already uploaded on GST portal in our #returnType.</p><br><p>Check GSTN Status column to know the status of Save to GSTN. Invoices marked as Saved will appear in your GSTR 2A.</p><br><p>Our (Supplier) GSTIN : #supplierGstin </p><br><p>Your (Purchaser) GSTIN : #purchaserGstin </p><br><p>We are sending you invoices which needs your further attention. The list of invoices can be downloaded from here.</p><br><p>' +
  '<a href="#downloadLink">Download Link</a></p><br><p>In case, you have any issues in the invoices so uploaded, please let us know.</p><br><p>Please note</p><br><p>The link will expire in 15 Days.</p><br><p>&nbsp;</p><br><p>Thank you</p><br><p>This email is generated and sent via <a target="' +
  '_' +
  '"  href="' +
  '#ownerLink' +
  '">#businessName</a>. Please do not reply to this email. For any queries with respect to #returnType invoice details, please contact the person marked in cc in this email</p>';

export const invoiceInputCols: TableColumn[] = [
  { key: 'dty', name: 'Document Type', show: true, removable: true },
  {
    key: 'inum',
    class: 'data-table-link',
    name: 'Document Number',
    show: true,
    removable: true,
    click(record) {},
  },
  {
    key: 'idt',
    name: 'Document Date',
    show: true,
    removable: true,
  },
  {
    key: 'ctin',
    class: 'data-table-link',
    name: 'GSTIN of counterparty',
    show: true,
    removable: true,
    click(record) {},
  },
  { key: 'cname', name: 'Name of Counterparty', show: true, removable: true },
  { key: 'val', name: 'Total Value', show: true, removable: true, isCurrency: true },
  // { key: 'gstnStatus', tags: { 'Mark for Deletion': 'tag-red', 'SAVED': 'tag-green', 'TO BE SAVED': 'tag-orange' },  name: 'GSTN Status', show: true, removable: true },
  // { key: 'errorWarning', name: 'Error Warning', show: true, removable: true },
  { key: 'category', name: 'Reconciliation Category', show: true, removable: true },
  {
    key: 'gstnStatus',
    tags: {
      'Mark for Deletion': 'tag-red',
      'SAVED': 'tag-green',
      'TO BE SAVED': 'tag-orange',
    },
    name: 'GSTN Status',
    show: true,
    removable: true,
  },
  {
    key: 'errorWarning',
    name: 'Error/Warning',
    show: true,
    removable: true,
    actionColumn: true,
  },
];

export const viewUploadSupplierToSmall: TableColumn[] = [
  { key: 'pos', name: 'Place of Supply', show: true, removable: true },
  { key: 'dst', name: 'Document Status', show: true, removable: true },
  { key: 'splyTy', name: 'Supply Type', show: true, removable: true },
  { key: 'omon', name: 'Original Month', show: true, removable: true },
  { key: 'diff', name: 'Difference %', show: true, removable: true },
  {
    key: 'txval',
    name: 'Total Taxable Value',
    show: true,
    removable: true,
    isCurrency: true,
  },
  {
    key: 'etin',
    name: 'GSTIN of e- commerce operator (if applicable)',
    show: true,
    removable: true,
  },
  { key: 'irt', name: 'IGST Rate', show: true, removable: true },
  { key: 'iamt', name: 'IGST Amount', show: true, removable: true, isCurrency: true },
  { key: 'crt', name: 'CGST Rate', show: true, removable: true },
  { key: 'camt', name: 'CGST Amount', show: true, removable: true, isCurrency: true },
  { key: 'srt', name: 'SGST/ UTGST Rate', show: true, removable: true },
  {
    key: 'samt',
    name: 'SGST/ UTGST Amount',
    show: true,
    removable: true,
    isCurrency: true,
  },
  { key: 'csrt', name: 'CESS Rate', show: true, removable: true },
  { key: 'csamt', name: 'CESS Amount', show: true, removable: true, isCurrency: true },
  {
    key: 'gstnStatus',
    tags: {
      'Mark for Deletion': 'tag-red',
      'SAVED': 'tag-green',
      'TO BE SAVED': 'tag-orange',
    },
    name: 'GSTN Status',
    show: true,
    removable: true,
  },
  {
    key: 'errorWarning',
    name: 'Error/Warning',
    show: true,
    removable: true,
    actionColumn: true,
  },
];

export const viewUploadNilExpt: TableColumn[] = [
  { key: 'splyTy', name: 'Supply Type', show: true, removable: true },
  { key: 'ctpy', name: 'Type of Counterparty', show: true, removable: true },
  {
    key: 'txp',
    name: 'Tax Applicability',
    show: true,
    removable: true,
  },
  { key: 'val', name: 'Value', show: true, removable: true, isCurrency: true },
];

export const advanceReceivedTaxPaid: TableColumn[] = [
  { key: 'dty', name: 'Document Type', show: true, removable: true },
  { key: 'dst', name: 'Document Status', show: true, removable: true },
  { key: 'splyTy', name: 'Supply Type', show: true, removable: true },
  { key: 'omon', name: 'Original Month', show: true, removable: true },
  { key: 'diff', name: 'Difference %', show: true, removable: true },
  { key: 'pos', name: 'Place of Supply', show: true, removable: true },
  {
    key: 'adAmt',
    name: 'Gross Advance Received/Adjusted',
    show: true,
    removable: true,
    isCurrency: true,
  },
  { key: 'irt', name: 'IGST Rate', show: true, removable: true },
  { key: 'iamt', name: 'IGST Amount', show: true, removable: true, isCurrency: true },
  { key: 'crt', name: 'CGST Rate', show: true, removable: true },
  { key: 'camt', name: 'CGST Amount', show: true, removable: true, isCurrency: true },
  { key: 'srt', name: 'SGST/ UTGST Rate', show: true, removable: true },
  {
    key: 'samt',
    name: 'SGST/ UTGST Amount',
    show: true,
    removable: true,
    isCurrency: true,
  },
  { key: 'csrt', name: 'CESS Rate', show: true, removable: true },
  { key: 'csamt', name: 'CESS Amount', show: true, removable: true, isCurrency: true },
  {
    key: 'gstnStatus',
    tags: {
      'Mark for Deletion': 'tag-red',
      'SAVED': 'tag-green',
      'TO BE SAVED': 'tag-orange',
    },
    name: 'GSTN Status',
    show: true,
    removable: true,
  },
  {
    key: 'errorWarning',
    name: 'Error/Warning',
    show: true,
    removable: true,
    actionColumn: true,
  },
];

export const viewUploadDocDetails: TableColumn[] = [
  { key: 'docNum', name: 'Document Number', show: true, removable: true },
  { key: 'docTyp', name: 'Nature of Document', show: true, removable: true },
  { key: 'num', name: 'Serial Number', show: true, removable: true },
  { key: 'from', name: 'From Serial Number', show: true, removable: true },
  { key: 'to', name: 'To Serial Number', show: true, removable: true },
  { key: 'totnum', name: 'Total Number', show: true, removable: true },
  { key: 'cancel', name: 'Cancelled', show: true, removable: true },
  { key: 'netIssue', name: 'Net Issued', show: true, removable: true },
];

export const viewUploadHsnSum: TableColumn[] = [
  { key: 'num', name: 'Serial Number', show: true, removable: true },

  { key: 'ty', name: 'Type (G-Goods/S-Services)', show: true, removable: true },
  { key: 'hsnSc', name: 'HSN/SAC', show: true, removable: true },
  {
    key: 'desc',
    name: 'Description (Optional If HSN is provided)',
    show: true,
    removable: true,
  },
  { key: 'uqc', name: 'UQC', show: true, removable: true },
  { key: 'rt', name: 'Rate', show: true, removable: true },
  { key: 'qty', name: 'Total Quantity', show: true, removable: true },
  { key: 'val', name: 'Total Value', show: true, removable: true, isCurrency: true },
  {
    key: 'txval',
    name: 'Total Taxable Value',
    show: true,
    removable: true,
    isCurrency: true,
  },
  { key: 'iamt', name: 'IGST Amount', show: true, removable: true, isCurrency: true },
  { key: 'camt', name: 'CGST Amount', show: true, removable: true, isCurrency: true },
  { key: 'samt', name: 'SGST Amount', show: true, removable: true, isCurrency: true },
  { key: 'csamt', name: 'CESS Amount', show: true, removable: true, isCurrency: true },
  {
    key: 'errorWarning',
    name: 'Error/Warning',
    show: true,
    removable: true,
    actionColumn: true,
  },
];

export const viewUploadSupplierEcomTrans: TableColumn[] = [
  { key: 'dty', name: 'Document Type', show: true, removable: true },
  { key: 'dst', name: 'Document Status', show: true, removable: true },
  { key: 'supTyp', name: 'Nature of Supply', show: true, removable: true },
  { key: 'etin', name: 'GSTIN of E-Commerce operator', show: true, removable: true },
  {
    key: 'omon',
    name: 'Original Month / Quarter',
    show: true,
    removable: true,
  },
  {
    key: 'oetin',
    name: 'Original GSTIN of e-commerce operator',
    show: true,
    removable: true,
  },
  {
    key: 'suppval',
    name: 'Net Value of Supplies',
    show: true,
    removable: true,
    isCurrency: true,
  },
  { key: 'iamt', name: 'IGST Amount', show: true, removable: true, isCurrency: true },
  { key: 'camt', name: 'CGST Amount', show: true, removable: true, isCurrency: true },
  {
    key: 'samt',
    name: 'SGST/ UTGST Amount',
    show: true,
    removable: true,
    isCurrency: true,
  },
  { key: 'csamt', name: 'CESS Amount', show: true, removable: true, isCurrency: true },
  {
    key: 'gstnStatus',
    tags: {
      'Mark for Deletion': 'tag-red',
      'SAVED': 'tag-green',
      'TO BE SAVED': 'tag-orange',
    },
    name: 'GSTN Status',
    show: true,
    removable: true,
  },
  {
    key: 'errorWarning',
    name: 'Error/Warning',
    show: true,
    removable: true,
    actionColumn: true,
  },
];

export const viewUploadEcomTransAgg: TableColumn[] = [
  { key: 'dty', name: 'Document Type', show: true, removable: true },
  { key: 'dst', name: 'Document Status', show: true, removable: true },
  { key: 'supTyp', name: 'Type of Supplier', show: true, removable: true },
  { key: 'splyTy', name: 'Supply Type', show: true, removable: true },
  { key: 'stin', name: 'GSTIN of Supplier', show: true, removable: true },
  {
    key: 'ostin',
    name: 'Original GSTIN of Supplier',
    show: true,
    removable: true,
  },
  { key: 'omon', name: 'Original Month', show: true, removable: true },
  { key: 'pos', name: 'Place of Supply', show: true, removable: true },
  {
    key: 'txval',
    name: 'Total Taxable Values',
    show: true,
    removable: true,
    isCurrency: true,
  },
  { key: 'rt', name: 'Tax Rate', show: true, removable: true },
  { key: 'irt', name: 'IGST Rate', show: true, removable: true },
  { key: 'iamt', name: 'IGST Amount', show: true, removable: true, isCurrency: true },
  { key: 'crt', name: 'CGST Rate', show: true, removable: true },
  { key: 'camt', name: 'CGST Amount', show: true, removable: true, isCurrency: true },
  { key: 'srt', name: 'SGST/ UTGST Rate', show: true, removable: true },
  {
    key: 'samt',
    name: 'SGST/ UTGST Amount',
    show: true,
    removable: true,
    isCurrency: true,
  },
  { key: 'csrt', name: 'CESS Rate', show: true, removable: true },
  { key: 'csamt', name: 'CESS Amount', show: true, removable: true, isCurrency: true },
  {
    key: 'gstnStatus',
    tags: {
      'Mark for Deletion': 'tag-red',
      'SAVED': 'tag-green',
      'TO BE SAVED': 'tag-orange',
    },
    name: 'GSTN Status',
    show: true,
    removable: true,
  },
  {
    key: 'errorWarning',
    name: 'Error/Warning',
    show: true,
    removable: true,
    actionColumn: true,
  },
];

export const viewUploadEcomInvLevelTrans: TableColumn[] = [
  { key: 'dty', name: 'Document Type', show: true, removable: true },
  {
    key: 'inum',
    class: 'data-table-link',
    name: 'Invoice / Document Number',
    show: true,
    removable: true,
  },
  { key: 'idt', name: 'Invoice / Document Date', show: true, removable: true },
  {
    key: 'stin',
    name: 'GSTIN/UIN Number of Supplier',
    show: true,
    removable: true,
  },
  {
    key: 'rtin',
    name: 'GSTIN/UIN Number of Recipient',
    show: true,
    removable: true,
  },
  {
    key: 'val',
    name: 'Total Invoice / Note Value',
    show: true,
    removable: true,
    isCurrency: true,
  },
  {
    key: 'category',
    name: 'Reconcilation Category',
    show: true,
    removable: true,
  },
  {
    key: 'gstnStatus',
    tags: {
      'Mark for Deletion': 'tag-red',
      'SAVED': 'tag-green',
      'TO BE SAVED': 'tag-orange',
    },
    name: 'GSTN Status',
    show: true,
    removable: true,
  },
  {
    key: 'errorWarning',
    name: 'Error/Warning',
    show: true,
    removable: true,
    actionColumn: true,
  },
];

export const einvoiceB2b: TableColumn[] = [
  { key: 'docType', name: 'Document Type', show: true, removable: true },
  { key: 'docStatus', name: 'Document Number', show: true, removable: true },
  { key: 'docStatus', name: 'Document Date', show: true, removable: true },
  { key: 'supplyType', name: 'Counterparty GSTIN', show: true, removable: true },
  { key: 'supplyType', name: 'Counterparty GSTIN Name', show: true, removable: true },
  { key: 'typeofSupply', name: 'Auto Drafted Status', show: true, removable: true },
  { key: 'typeofSupply', name: 'Auto Drafted Date', show: true, removable: true },
  { key: 'gstinSupply', name: 'Total Value', show: true, removable: true },
  { key: 'gstinSupply', name: 'IRN Status', show: true, removable: true },
];

export const einvoiceCDN: TableColumn[] = [
  { key: 'docType', name: 'Document Type', show: true, removable: true },
  { key: 'docStatus', name: 'Document Number', show: true, removable: true },
  { key: 'docStatus', name: 'Note Date', show: true, removable: true },
  { key: 'supplyType', name: 'Counterparty GSTIN', show: true, removable: true },
  {
    key: 'supplyType',
    name: 'Counterparty GSTIN Name',
    show: true,
    removable: true,
  },
  {
    key: 'typeofSupply',
    name: 'Auto Drafted Status',
    show: true,
    removable: true,
  },
  {
    key: 'typeofSupply',
    name: 'Auto Drafted Date',
    show: true,
    removable: true,
  },
  { key: 'gstinSupply', name: 'Total Value', show: true, removable: true },
  { key: 'gstinSupply', name: 'IRN Status', show: true, removable: true },
];

export const einvoiceEXP: TableColumn[] = [
  { key: 'docType', name: 'Document Type', show: true, removable: true },
  { key: 'docStatus', name: 'Document Number', show: true, removable: true },
  { key: 'docStatus', name: 'Document Date', show: true, removable: true },
  { key: 'supplyType', name: 'Invoice Type', show: true, removable: true },
  {
    key: 'typeofSupply',
    name: 'Auto Drafted Status',
    show: true,
    removable: true,
  },
  {
    key: 'typeofSupply',
    name: 'Auto Drafted Date',
    show: true,
    removable: true,
  },
  { key: 'gstinSupply', name: 'Total Value', show: true, removable: true },
  { key: 'gstinSupply', name: 'IRN Status', show: true, removable: true },
];

export const einvoiceCDNUR: TableColumn[] = [
  { key: 'docType', name: 'Document Type', show: true, removable: true },
  { key: 'docStatus', name: 'Document Number', show: true, removable: true },
  { key: 'docStatus', name: 'Document Date', show: true, removable: true },
  { key: 'supplyType', name: 'Invoice Type', show: true, removable: true },
  {
    key: 'typeofSupply',
    name: 'Auto Drafted Status',
    show: true,
    removable: true,
  },
  {
    key: 'typeofSupply',
    name: 'Auto Drafted Date',
    show: true,
    removable: true,
  },
  { key: 'gstinSupply', name: 'Total Value', show: true, removable: true },
  { key: 'gstinSupply', name: 'IRN Status', show: true, removable: true },
];

export interface AccessControlStatus {
  status: string;
}

export const accessControlList: { [key: string]: AccessControlStatus } = {
  '1': { status: 'PENDING SUBMISSION' },
  '2': { status: 'DRAFT' },
  '3': { status: 'PENDING FOR REVIEW' },
  '4': { status: 'REVIEWED' },
  '5': { status: 'SUBMITTED' },
  '6': { status: 'ESIGN SUCCESSFULLY' },
  '7': { status: 'ESIGN UNSUCCESSFUL' },
  '8': { status: 'FILED' },
  '9': { status: 'PENDING FOR RETURN CREATION' },
  '10': { status: 'FAILED' },
  '11': { status: 'IN PROGRESS' },
  '12': { status: 'READY TO FILE' },
};

export const GSTIN_STATUS = [
  { id: 1, name: 'Saved', value: '1' },
  { id: 2, name: 'To be Saved', value: '2' },
  { id: 3, name: 'Mark for deletion', value: '3' },
];

export const DOCUMENT_TYPE_GSTR6 = [
  { id: 1, name: 'Regular Invoice', value: 'RI' },
  { id: 3, name: 'Credit Note', value: 'C' },
  { id: 4, name: 'Debit Note', value: 'D' },
];

export const DOCUMENT_TYPE_GSTR6_ISD = [
  { id: 1, name: 'Regular Invoice', value: 'ISDINV' },
  { id: 3, name: 'Credit Note', value: 'ISDCN' },
  { id: 4, name: 'Debit Note', value: 'ISDDB' },
];

export const INVOICE_TYPES = [
  { id: 1, name: 'Regular B2B', value: 'B2B' },
  { id: 2, name: 'Regular B2CL', value: 'B2CL' },
  { id: 3, name: 'Regular B2CS', value: 'B2CS' },
  { id: 4, name: 'SEZ With Payment', value: 'SEWP' },
  { id: 5, name: 'SEZ Without Payment', value: 'SEWOP' },
  { id: 6, name: 'Export With Payment Of Duty', value: 'EXWP' },
  { id: 7, name: 'Export Without Payment Of Duty', value: 'EXWOP' },
  { id: 8, name: 'Deemed Exports', value: 'DE' },
  { id: 9, name: 'Customs Bonded Warehouse (CBW)', value: 'CBW' },
];

export const INVOICE_TYPES_GSTR6 = [
  { id: 1, name: 'Regular B2B', value: 'B2B' },
  { id: 3, name: 'SEZ Without Payment', value: 'SEWOP' },
  { id: 4, name: 'Deemed Exports', value: 'DE	' },
  { id: 5, name: 'SEZ With Payment', value: 'SEWP' },
  { id: 6, name: 'Import of Service', value: 'IMS' },
  { id: 7, name: 'Import of Goods', value: 'IMG' },
  { id: 8, name: 'Reverse Charge Self Invoice', value: 'RCM' },
  { id: 9, name: 'B2B Unregistered', value: 'B2BUR' },
];

export const DOCUMENT_STATUS = [
  {
    value: 'O',
    name: 'Original',
  },
  {
    value: 'R',
    name: 'Revised',
  },
];

export const AUTODRAFTED_STATUS = [
  { value: 'Auto-populated', name: 'Auto-populated' },
  { value: 'Deletion failed', name: 'Deletion failed' },
  { value: 'Deleted', name: 'Deleted' },
  { value: 'Auto-population failed', name: 'Auto-population failed' },
];

export const EINVOICE_STATUS = [
  { value: 'ACT', name: 'Active' },
  { value: 'CNL', name: 'Cancelled' },
];

export const NATURE_OF_SUPPLY_TYPE = [
  {
    value: 'Ecom52',
    name: 'Ecom52',
  },
  {
    value: 'Ecom9(5)',
    name: 'Ecom9(5)',
  },
];

export const ERROR_WARNING = [
  {
    value: 'error',
    name: 'Error',
  },
  {
    value: 'warning',
    name: 'Warning',
  },
];

export const DOCUMENT_TYPE = [
  { id: 1, name: 'Regular Invoice', value: 'RI' },
  { id: 2, name: 'Bill of supply', value: 'BS' },
  { id: 3, name: 'Credit Note', value: 'C' },
  { id: 4, name: 'Debit Note', value: 'D' },
  { id: 5, name: 'Refund Voucher', value: 'R' },
  { id: 6, name: 'Receipt Voucher', value: 'RV' },
  { id: 7, name: 'Tax Paid', value: 'TP' },
];

export const RECON_CATEGORY_TYPE = [
  { id: 1, name: 'MATCH', value: 'MATCH' },
  { id: 2, name: 'MISMATCH', value: 'MISMATCH' },
  { id: 3, name: 'ONLY IRN', value: 'ONLY IRN' },
  { id: 4, name: 'NO IRN', value: 'NO IRN' },
];

export const GSTR1_RECON_STATUS_CONFIG = {
  NO_DATA_UPLOAD: {
    label: 'No Data Upload',
    description: 'No data has been uploaded for verification',
    class: 'tag-gray',
  },
  EINV_DATA_NOT_FOUND: {
    label: 'E-Invoice Data Not Found',
    description: 'Required e-invoice data could not be located',
    class: 'tag-gray',
  },
  RECON_IN_PROGRESS: {
    label: 'Reconciliation In Progress',
    description: 'Data reconciliation process is ongoing',
    class: 'tag-orange',
  },
  UPLOAD_IN_PROGRESS: {
    label: 'Upload In Progress',
    description: 'File upload process is in progress',
    class: 'tag-orange',
  },
  DELETE_IN_PROGRESS: {
    label: 'Delete In Progress',
    description: 'Data deletion process is ongoing',
    class: 'tag-orange',
  },
  GET_IN_PROGRESS: {
    label: 'Get In Progress',
    description: 'Retrieving required information from server',
    class: 'tag-orange',
  },
  DRAFT: {
    label: 'Draft',
    description: 'Document is in draft state and pending submission',
    class: 'tag-blue',
  },
  FILED: {
    label: 'Filed',
    description: 'Document has been successfully submitted',
    class: 'tag-green',
  },
  // Default fallback (optional)
  _DEFAULT: {
    label: 'Unknown',
    description: 'Status information not available',
    class: '',
  },
  INVALID_SESSION: {
    label: 'Invalid Session',
    description: 'Invalid session',
    class: 'tag-red',
  },
};
